import _ from 'underscore';

import ScrollManager from 'components/manager/ScrollManager';
import ImageManager from 'components/manager/ImageManager';

import Header from 'components/sections/Header';
import ProjectList from 'components/sections/ProjectList';

import MobileDetect from 'mobile-detect';


class Application {

  constructor() {
    this.el = document.querySelector('#application');

    ImageManager.start();
    this.buildSections();
    this.addEvents();

    this.animateCover();
    this.detectDevice();
  }

  detectDevice() {
    var md = new MobileDetect(navigator.userAgent);
    document.body.classList.add((md.mobile() ? '':'no-')+'mobile');
  }

  animateCover() {
    const cover = this.el.querySelector('#cover');
    setTimeout(()=> cover.classList.add('show'), 1000);
    setTimeout(()=> cover.classList.add('hide'), 3000);
  }

  buildSections() {
    this.header = new Header(this.el.querySelector('#header'));
    this.projectList = new ProjectList(this.el.querySelector('#project-list'))
  }

  addEvents() {
    window.addEventListener('resize', this.onResize);
    const links = this.el.querySelectorAll('.scrollto');
    _.each(links, (el)=> el.addEventListener('click', this.scrollToSection))
  }

  scrollToSection = (event) => {
    const el = event.currentTarget;
    const target = this.el.querySelector(el.getAttribute('href'));

    if (!target) return;

    ScrollManager.scrollTo(target);
    event.preventDefault();
  }

  onResize = () => {
    ImageManager.onResize();
    this.header.onResize();
  }
}

export default Application;



// WEBPACK FOOTER //
// ./src/components/Application.js